import { apiClient } from "@api/apiClient";

import { DefaultAIAdvisorResponseData } from "./aiAdvisor.interface";

const API_ENDPOINT = "des/ai-advice-data/info/";

export const aiAdvisorApi = {
  getAiAdvisorData: async (pressId: string) => {
    const response = await apiClient.get<DefaultAIAdvisorResponseData>(
      `${API_ENDPOINT}${pressId}`,
    );

    return response.data;
  },
};
